<template>
  <v-fade-transition>
    <v-row class="ma-0" v-show="isSticky">
      <v-col id="sticky-nav-bar" class="is_sticky" justify="center">
        <div>
          <nav-bar-item identifierId="about-me">
            About
          </nav-bar-item>
          <nav-bar-item identifierId="tech-stacks">
            Skills
          </nav-bar-item>
          <nav-bar-item identifierId="tech-projects">
            Projects
          </nav-bar-item>
          <nav-bar-item identifierId="work-experience">
            Experience
          </nav-bar-item>
        </div>
      </v-col>
    </v-row>
  </v-fade-transition>
  <v-row class="ma-0">
    <!-- empty filler to avoid jumpy transitions -->
    <v-col id="nav-bar-filler" class="is_sticky">.</v-col>
  </v-row>
</template>

<script>
import NavBarItem from './NavBarItem.vue';
export default {
  name: 'NavBar',

  components: {
    NavBarItem,
  },

  data() {
    return {
      isSticky: false,
      stickyClass: 'is_sticky',
      scrollPosition: 0,
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.scrollPosition = window.scrollY;
      this.isSticky = this.scrollPosition >= window.innerHeight - 80;
    },
  },
};
</script>

<style lang="scss" scoped>
#sticky-nav-bar {
  background-color: white;
  width: 100vw;
  padding: 3px;
  z-index: 900;
}

#nav-bar-filler {
  width: 100vw;
  padding: 3px;
}

.is_sticky {
  position: fixed;
  top: 0;
  left: 0;
}
</style>
